// extracted by mini-css-extract-plugin
export default {"sectionBasic":"sectionResumeBasic_sectionBasic__jRrgH","sectionTitle":"sectionResumeBasic_sectionTitle__gM1SI","sectionContent":"sectionResumeBasic_sectionContent__s8HKA"};